import { PlainButton } from "@components/Button/styles"
import React, { FC } from "react"
import { z } from "zod"
import jsonp from "jsonp"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { Container } from "@components/styles"
import Pattern from "@components/EffiePattern"
import { theme } from "@theme/stitches.config"
import InputField from "@components/FormFields/InputField"
import { messages } from "@i18n/messages/nl"
import { Error, Succes } from "@components/FormFields/styles"
import {
    Content,
    NewsletterWrapper,
    Styledform,
    StyledEffiePatternWrapper,
    Description,
    FormWrapper
} from "./styles"
import { NewsletterProps } from "./types"

const schema = z.object({
    firstName: z.string().nonempty({ message: messages.fieldRequired }),
    lastName: z.string().nonempty({ message: messages.fieldRequired }),
    email: z.string().email({ message: messages.emailAddress })
})

type FormSchema = z.infer<typeof schema>

const Newsletter: FC<NewsletterProps> = ({
    content,
    description
}) => {
    const {
        register, handleSubmit, setError, reset, formState: { errors }
    } = useForm<FormSchema>({ resolver: zodResolver(schema) })

    const onSubmit = async (values: FormData) => {
        const mailchimpData = {
            email: values.email,
            FNAME: values.firstName,
            LNAME: values.lastName
        }

        const subscribeUrl = `${process.env.GATSBY_MAILCHIMP_URL}&EMAIL=${encodeURIComponent(mailchimpData.email)}&FNAME=${encodeURIComponent(mailchimpData.FNAME)}&LNAME=${encodeURIComponent(mailchimpData.LNAME)}`

        jsonp(
            subscribeUrl,
            {
                param: "c"
            },
            (err: string, data: {result: string, msg: string}) => {
                if (err) {
                    setError("formError", {
                        type: "manual",
                        message: messages.formError
                    })
                } else if (data.result !== "success") {
                    setError("formError", {
                        type: "manual",
                        message: messages.formError
                    })
                } else {
                    reset()
                    setError("formFeedback", {
                        type: "manual",
                        message: "U bent aangemeld voor de nieuwsbrief"
                    })
                }
            }
        )
    }

    return <Container>
        <NewsletterWrapper>
            <Content dangerouslySetInnerHTML={{ __html: content }} />
            <FormWrapper>
                <Styledform
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        {...register("firstName")}
                        id="firstName"
                        label="voornaam"
                        error={errors?.firstName?.message}
                        placeholder="Jan"
                    />
                    <InputField
                        {...register("lastName")}
                        id="lastName"
                        label="achternaam"
                        error={errors?.lastName?.message}
                        placeholder="Janssen"
                    />
                    <InputField
                        id="email"
                        label="Email"
                        error={errors?.email?.message}
                        placeholder="hi@janjanssen.nl"
                        {...register("email")}
                    />
                    <PlainButton
                        type="submit"
                        filled="gold"
                    >
                        subscribe
                    </PlainButton>
                </Styledform>
                {errors.formError && <Error>{errors.formError.message}</Error>}
                {errors.formFeedback && <Succes>{errors.formFeedback.message}</Succes>}
                <Description>{description}</Description>
            </FormWrapper>
            <StyledEffiePatternWrapper>
                <Pattern stroke={theme.colors.effieGold} />
            </StyledEffiePatternWrapper>
        </NewsletterWrapper>
    </Container>
}

export default Newsletter
